<template>
<v-card class="pa-3">
    <div class="d-flex align-center justify-center fill-height">
        <div>
            <input type="tel" v-model="hour" maxlength="5" placeholder="HH:mm" class="time-picker" id="input_picker">
        </div>
    </div>
</v-card>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            hour: this.value,
        }
    },
    mounted() {
        document.getElementById("input_picker")
            .focus();
        // this.$refs.input_picker.focus()
    },
    watch: {
        hour(newValue, oldValue) {
            let regex = /0[0-9]|1[0-9]|2[0-3]/;
            let regex_dec = /[3-9]{1}/;
            let regex_2hour = /[4-9]{1}/;
            let regex_number = /[0-9]{1}/;
            let chars_allowed = /[0-9]|[:]/;
            let regex_1min = /[0-5]{1}/;
            let aux = "";
            if(!(newValue == null || newValue == "")) {
                if(!chars_allowed.test(newValue.slice(-1))) {
                    aux = newValue.slice(0, -1);
                    this.hour = aux;
                }
                if(newValue.length == 2 && regex_2hour.test(newValue[1])) {
                    if(newValue[0] == 2) {

                        if(regex_1min.test(newValue[1])) {
                            aux = "0" + newValue[0] + ":" + newValue[1];
                        } else {
                            aux = "0" + newValue[0] + ":0" + newValue[1];
                        }
                        this.hour = aux;
                    }
                }
                if(!regex.test(newValue)) {
                    if(regex_dec.test(newValue) && newValue.length < 2) {
                        aux = "0" + this.hour + ":";
                        this.hour = aux;
                        return
                    }
                }
                if(newValue.length == 2 && oldValue.length !== 3 && regex.test(newValue)) {
                    this.hour = newValue + ":";
                    return
                }
                if(newValue.length <= 3) {
                    if(!regex_number.test(newValue.slice(-1))) {
                        if(newValue[2] !== ":" && newValue.length !== 3) {
                            this.hour = oldValue;
                        }
                    } else {
                        if(newValue[2] !== ":" && newValue.length == 3) {
                            aux = newValue.slice(0, -1) + ":" + newValue.slice(-1)
                            this.hour = aux;
                        }
                    }
                } else {
                    if(!regex_number.test(newValue.slice(-1))) {
                        if(newValue[2] == ":" && newValue.length !== 3) {
                            this.hour = oldValue;
                            return
                        }
                    } else {
                        if(regex_1min.test(newValue.slice(-1))) {
                            aux = newValue.slice(0, -1) + newValue[1];
                        } else {
                            if(newValue.length < 5) {
                                aux = newValue.slice(0, -1) + "0" + newValue.slice(-1);
                                this.hour = aux;
                                return
                            }
                        }
                    }
                }
            }
            let regex_24h = /[0-2]{1}[0-9]{1}:[0-5]{1}[0-9]{1}/;
            if(regex_24h.test(this.hour)) {
                // emit value for update
                this.$emit('update', this.hour);
            }

        },
        value: {
            handler() {
                document.getElementById("input_picker")
                    .focus();
                this.hour = this.value;
            }
        },
    },
}
</script>
<style lang="stylus">
input
    &.time-picker
        font-size: 28px
        font-weight: 600
        outline: none
        text-align: center
</style>
